export const BASE_IMAGE_PATH = './assets/img';

export const APP_LOGO_PATH = `${BASE_IMAGE_PATH}/logo.png`;
export const MAP_MARKER_PATH = `${BASE_IMAGE_PATH}/marker.png`;
export const LOGIN_BACKGROUND_PATH = `${BASE_IMAGE_PATH}/login-background.png`;
export const ROTATE_DEVICE_IMAGE_PATH = `${BASE_IMAGE_PATH}/rotate-device.png`;

export const CART = `${BASE_IMAGE_PATH}/cart.svg`;
export const TRANSACTION = `${BASE_IMAGE_PATH}/transactionIcon.svg`;
export const REWARD_POINTS_IMAGE_PATH = `${BASE_IMAGE_PATH}/points.png`;
export const REWARD_CASHBACK_IMAGE_PATH = `${BASE_IMAGE_PATH}/cashback.png`;
